module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_09-f155acc3120e05676e7282f80a553a5e.jpg";